var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("date-range-picker", {
    ref: "dateRangePicker",
    attrs: {
      singleDatePicker: !_vm.range,
      timePicker: _vm.timePicker,
      timePicker24Hour: true,
      showWeekNumbers: true,
      showDropdowns: true,
      ranges: false,
      autoApply: false,
      readonly: _vm.disabled,
      "date-range": _vm.selectedValue,
      linkedCalendars: true,
      "time-picker-increment": 1
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function(picker) {
          return [
            _vm.range
              ? _c("span", [
                  _vm._v(
                    _vm._s(_vm._f("date")(picker.startDate, _vm.timePicker)) +
                      " - " +
                      _vm._s(_vm._f("date")(picker.endDate, _vm.timePicker))
                  )
                ])
              : _c("span", [
                  _vm._v(
                    _vm._s(_vm._f("date")(picker.startDate, _vm.timePicker))
                  )
                ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf1d6d3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf1d6d3a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NextDatePicker2.vue
// module id = null
// module chunks = 